import { render, staticRenderFns } from "./ExportMarketingForm.vue?vue&type=template&id=e5faff6e"
import script from "./ExportMarketingForm.vue?vue&type=script&lang=js"
export * from "./ExportMarketingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports